import NetworkShareMutations from './mutations-types'

export default {
  [NetworkShareMutations.SET_USER_NETWORK_SHARES](state, userNetworkShares) {
    state.userNetworkShares = [...userNetworkShares]
  },
}
